const state = {
  service: "",
  subservice: "",
  service_label: "",
  totalShoppingCart: 0,
  countProductsList: 0,
  purchaseId: null,
  transaction: null,
  taPurchaseId: null,
  otPurchaseId: null,
  tip: {
    include: 'YES',
    percent: 10,
    customValue: ''
  },
  idsProductsOnCart: [],
  shoppingCart: { total: 0 }
};

const getters = {
  service: state => {
    return state.service;
  },
  subservice: state => {
    return state.subservice;
  },
  transaction_id: state => {
    return state.transaction.id;
  },
  is_delivery_service: state => {
    return state.service === 'delivery' || state.service === 'take_away';
  },
  is_take_away_service: state => {
    return state.service === 'take_away';
  },
  is_ontable_service: state => {
    return state.service === 'on_table';
  },
  is_room_service: state => {
    return state.service === 'on_table' && state.subservice == 'room';
  },
  show_impoconsumo_label: (state, getters, rootState, rootGetters)  => {
    rootGetters
    return state.tip.percent !== undefined && [ 'la-mia', 'demo-chicken-box'].includes(rootState.customer.instance.slug);
    // return state.tip.percent !== undefined && rootState.customer.instance.slug === 'la-mia';
  },
  minValueOrder:(state, getters, rootState, rootGetters) => {
    return rootGetters['customer/is_colombian_customer'] ? 10000 : rootGetters['customer/is_mexican_customer'] ? 50 : 0;
  }
};

const actions = {
  setMenuDigital({ dispatch, commit }){
    commit('setMenuDigital');
    dispatch('hidePanelLeft');
  },
  setDelivery({ dispatch, commit }){
    commit('setDelivery');
    dispatch('hidePanelLeft');
  },
  setTakeAway({ dispatch, commit }){
    commit('setTakeAway');
    commit('customer/SetPolygon', {
      id: "",
      delivery_price: 0,
      minimum_order_value: 0,
      supplier_id: 0
    },{root: true});
    dispatch('hidePanelLeft');
  },
  setBook({ dispatch, commit }){
    commit('setBook');
    dispatch('hidePanelLeft');
  },
  setServiceRoom({ dispatch, commit }){
    commit('setServiceRoom');
    dispatch('hidePanelLeft');
  },
  setSchedule({ dispatch, commit }){
    commit('setSchedule');
    dispatch('hidePanelLeft');
  },
  hidePanelLeft({commit}) {
    commit('template/CloseLeftPanel', false, { root: true });
  }
};

const mutations = {
  setMenuDigital(state) {
    state.service = "on_table";
    state.subservice = "";
    state.service_label = "En mesa";
  },
  setDelivery(state) {
    state.service = "delivery";
    state.subservice = "";
    state.service_label = "Delivery";
  },
  setTakeAway(state) {
    state.service = "take_away";
    state.subservice = "";
    state.service_label = "Para llevar";
  },
  setBook(state) {
    state.service = "book";
    state.subservice = "";
    state.service_label = "Reservar";
  },
  setServiceRoom(state) {
    state.service = "on_table";
    state.subservice = "room";
    state.service_label = "En habitacion";
  },
  setSchedule(state) {
    state.service = "delivery";
    state.subservice = "schedule";
    state.service_label = "Programar pedido";
  },
  setService(state, data) {
    if (data === "room_service") {
      state.subservice = "room";
      state.service = "on_table";
      state.service_label = "En habitacion";
    }
    if (data === "on_table") {
      state.service = data;
      state.service_label = "En mesa";
      state.subservice = "";
    }
    if (data === "delivery") {
      state.service = data;
      state.service_label = "Delivery";
    }
    if (data === "take_away") {
      state.service = data;
      state.service_label = "Para llevar";
    }
    if (data === "") {
      state.subservice = "";
      state.service = "";
      state.service_label = "";
    }
    if(data === "book") {
      state.subservice = "";
      state.service = "book";
      state.service_label = "Reservar";
    }
  },
  SetTotalShoppingCart(state, data) {
    state.totalShoppingCart = data;
  },
  SetCountProductsList(state, data) {
    state.countProductsList = data;
  },
  SetPurchaseId(state, data) {
    state.purchaseId = data;
    if (data === null) {
      state.countProductsList = 0;
    }
  },
  SetTaPurchaseId(state, data) {
    state.taPurchaseId = data;
    if (data === null) {
      state.countProductsList = 0;
    }
  },
  SetTransaction(state, data) {
    state.transaction = data;
  },
  SetOtPurchaseId(state, data) {
    state.otPurchaseId = data;
    if (data === null) {
      state.countProductsList = 0;
    }
  },
  setTip(state, data) {
    if(data.include) state.tip.include = data.include;
    state.tip.percent = data.percent;
    if(data.customValue >= 0) state.tip.customValue = data.customValue
  },
  setIdProductsOnCartPush(state,data) {
    const ids = state.idsProductsOnCart;
    ids.push(data);
    state.idsProductsOnCart = [...ids];
  },
  setIdProductsOnCartSplice(state,data) {
    const ids = [...state.idsProductsOnCart];
    const idx = ids.findIndex(id => id === data);
    if (idx > -1) {
      ids.splice(idx,1);
      state.idsProductsOnCart = ids;
    }
  },
  resetIdsProductsOnCart(state, data) {
    state.idsProductsOnCart = [...data];
  },
  setShoppingCart(state, data) {
    state.shoppingCart = data;
  }

};

export default {
  preserveState: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
